export { default as HallmarkChannelLogo } from './HallmarkChannelLogo';
export { default as HallmarkChannelLogoPNG } from './hallmarkChannel.png';
export { default as HallmarkMoviesAndMysteriesLogo } from './hallmarkMoviesAndMysteries.svg';
export { default as StackedLogo } from './logo.svg';
export { default as GameSponsorLogo } from './sponsorLogo.svg';
export { default as HorizontalLogo } from './logo_horizontal.svg';
export { default as HallmarkLogoCard } from './hallmark-channel-logo-card.svg';
export const LoveuaryLogo = 'https://1240369105.rsc.cdn77.org/loveuary/static/loveuary-logo.svg';
